import React from 'react'
import './Footer.css'
import {AiOutlineTwitter} from 'react-icons/ai'
import {BsFacebook }from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'
import { AiFillLinkedin } from 'react-icons/ai'

const Footer = () => {
  return (
    <footer>
      <a href='/' className='footer_logo'> GURI  TECH</a>

      <ul className='permalinks'>
        <li> <a href='/'> Home</a></li>
        <li> <a href='#about'> About</a></li>
        <li> <a href='#experience'> Experience</a></li>
       
        <li> <a href='#portfolio'>Portfolio</a></li>
        
        <li> <a href='#contact'> Contact</a></li>
      </ul>

      <div className='footer_socials'>
      <a href='/'><BsFacebook/></a>
      <a href='/'><BsInstagram/></a>
      <a href='/'><AiOutlineTwitter/></a>
      <a href='https://ca.linkedin.com/in/gurpreet-singh-ba93891a0'><AiFillLinkedin/></a>
      
            </div>

      <div className='footer_copyright'>
        <small>Design by gurpreet</small>
      </div>
    </footer>
  )
}

export default Footer